import { Pagination } from '@/components/shared/Pagination';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { formatDataHora } from '@/lib/utils/formatters';
import { POR_PAGINA, useTabEventos } from '../GestaoDocumentosProvider';

interface Props {
  chaveAcesso: string;
  codigoModelo: string;
}

export function TabEventos({ chaveAcesso, codigoModelo }: Props) {
  const { pagina, setPagina, todos, isLoading, totalPaginas, pagAtual } = useTabEventos(
    chaveAcesso,
    codigoModelo
  );

  return (
    <div className="space-y-3">
      <div className="overflow-auto rounded-md border">
        <Table>
          <TableHeader className="bg-[#f7f7f7]">
            <TableRow>
              <TableHead>Descrição</TableHead>
              <TableHead>Código</TableHead>
              <TableHead>Mensagem</TableHead>
              <TableHead>Autor</TableHead>
              <TableHead>Origem</TableHead>
              <TableHead>Data/Hora Envio</TableHead>
              <TableHead>Data/Hora Recibo</TableHead>
              <TableHead>Data Exclusão</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {isLoading ? (
              Array.from({ length: POR_PAGINA }).map((_, index) => (
                <TableRow key={index}>
                  {Array.from({ length: 8 }).map((__, cellIndex) => (
                    <TableCell key={cellIndex}>
                      <div className="h-3.5 w-3/4 rounded bg-muted animate-pulse" />
                    </TableCell>
                  ))}
                </TableRow>
              ))
            ) : todos.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} className="py-10 text-center text-sm text-muted-foreground">
                  Nenhum evento encontrado.
                </TableCell>
              </TableRow>
            ) : (
              pagAtual.map((evento, idx) => (
                <TableRow key={`${evento.Chave}-${(pagina - 1) * POR_PAGINA + idx}`}>
                  <TableCell className="min-w-[220px] text-sm font-medium">
                    {evento.Descricao || '—'}
                  </TableCell>
                  <TableCell className="whitespace-nowrap text-xs font-mono">
                    {evento.CodigoResposta || '—'}
                  </TableCell>
                  <TableCell className="min-w-[280px] text-sm">
                    {evento.MensagemResposta || '—'}
                  </TableCell>
                  <TableCell className="whitespace-nowrap text-sm">
                    {evento.DocumentoAutor || '—'}
                  </TableCell>
                  <TableCell className="whitespace-nowrap text-sm">
                    {evento.Origem || '—'}
                  </TableCell>
                  <TableCell className="whitespace-nowrap text-sm">
                    {formatDataHora(evento.DataHoraEnvio)}
                  </TableCell>
                  <TableCell className="whitespace-nowrap text-sm">
                    {formatDataHora(evento.DataHoraRecibo)}
                  </TableCell>
                  <TableCell className="whitespace-nowrap text-sm">
                    {formatDataHora(evento.DataExclusao)}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </div>

      {todos.length > 0 && (
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <span className="shrink-0">{todos.length} evento(s)</span>
          <div className="flex-1">
            <Pagination currentPage={pagina} totalPages={totalPaginas} onPageChange={setPagina} />
          </div>
        </div>
      )}
    </div>
  );
}
